export const MEMCACHE_LOGIN = 'MEMCACHE_LOGIN'
export const LOGIN_OUT = 'LOGIN_OUT'
export const ACCOUNT_LOGIN = 'ACCOUNT_LOGIN'
